import { render, staticRenderFns } from "./AddNewAndEditDisableReason.vue?vue&type=template&id=2d9153ef&scoped=true"
import script from "./AddNewAndEditDisableReason.vue?vue&type=script&lang=js"
export * from "./AddNewAndEditDisableReason.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9153ef",
  null
  
)

export default component.exports